import Stack from '@mui/material/Stack'

export default function AuthClassicLayout({children}) {
  const renderContent = (
    <div style={{background: '#fff', width: '100%'}}>
      <Stack
        sx={{
          width: 1,
          mx: 'auto',
          maxWidth: 460,
          px: {xs: 2, md: 2, lg: 2},
          py: {xs: 3, md: 3, lg: 3},
        }}
      >
        {children}
      </Stack>
    </div>
  )

  return (
    <Stack
      component="main"
      direction="row"
      sx={{
        minHeight: '100vh',
      }}
    >
      {renderContent}
    </Stack>
  );
}
